import PropTypes from 'prop-types'

import Icon from 'components/Shared/Icon/Index'

const IconLink = ({ onClick, hoverable = true, visible = true, ...otherProps }) => {
  return (
    visible && <Icon onClick={onClick} hoverable={hoverable} {...otherProps} />
  )
}

IconLink.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  hoverable: PropTypes.bool,
  children: PropTypes.node,
  iconName: PropTypes.string.isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func,
  vertical: PropTypes.bool,
  visible: PropTypes.bool,
}

export default IconLink
